import { useState, useEffect } from "react";
import { Link, useFetcher, useLocation, useParams } from "react-router-dom";
import { Icon } from 'react-icons-kit'
import { chevronRight } from 'react-icons-kit/ionicons/chevronRight'
import { iosArrowRight } from 'react-icons-kit/ionicons/iosArrowRight'
import styles from "../pages/OnBoarding/UserOnboarding1.module.css";
import helper from "./helpers.module.css"
import { useSelector } from "react-redux";
import { localDataKeys } from "./constant";

const getUser = () => {
  const storedData = localStorage.getItem('persist:root');
  let user_name = "unknown"
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    const User = JSON.parse(parsedData?.User);
    return User.user_name
  }
  return user_name;
}
export const formatAmount=(amount)=> {
  if (amount >= 1000 && amount < 1000000) {
    return (amount / 1000).toFixed(amount % 1000 === 0 ? 0 : 1) + "k";
  } else if (amount >= 1000000 && amount < 1000000000) {
    return (amount / 1000000).toFixed(amount % 1000000 === 0 ? 0 : 1) + "M";
  } else if (amount >= 1000000000) {
    return (amount / 1000000000).toFixed(amount % 1000000000 === 0 ? 0 : 1) + "B";
  }
  return amount.toString();
}

export const IssuerDate = ({ dateString }) => {
  var date = new Date(dateString);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var ddmmyy = date.getDate().toString().padStart(2, '0') + ' ' + months[date.getMonth()] + " " + date.getFullYear()
  var hhmm = date.getHours() + ":" + date.getMinutes().toString().padStart(2, '0');
  return (ddmmyy + " | " + hhmm)
}

export const convertDateFormat = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  return `${day}-${month}-${year}`;
}

// Error bodies for blob responses (responseType: "blob") arrive as a Blob, so
// `err.response.data.message` is always undefined. Read the blob as text, parse
// it, and surface the backend's `message` (falling back to a generic string).
export const parseBlobError = async (err, fallback = "Something went wrong") => {
  try {
    const text = await err?.response?.data?.text();
    return JSON.parse(text)?.message || fallback;
  } catch {
    return fallback;
  }
}

export const isInternalUser = () => {
  const User = useSelector(state => state.User)
  return (User.user_type == 'internal_user' || User.user_type=="Super Admin" ? 1 : 0)
}


export const getUserId = () => {
  const User = useSelector(state => state.User)
  return User.id
}

export const AuthConsole=(...args)=>{
  if(window.location.href.includes("localhost")){
  return console.log(...args);
  }
  
}
export const Loader = () => {
  return (<div className={helper.loader}>Loading Data... Please wait</div>)
}

export const Timer = ({ m, getOTP }) => {
  const totalSeconds = m * 60

  const [time, settime] = useState(() => {
    const savedTime = localStorage.getItem("remainingTime");
    const savedTimestamp = localStorage.getItem("savedTimestamp");
    if (savedTime && savedTimestamp) {
      const timeElapsed = Math.floor((Date.now() - savedTimestamp) / 1000);
      return Math.max(parseInt(savedTime) - timeElapsed, 0);
    }
    return totalSeconds;
  });

  const [resend, setResend] = useState(false);

  useEffect(() => {
    // Save timer to localStorage on mount
    localStorage.setItem("remainingTime", time);
    localStorage.setItem("savedTimestamp", Date.now());

    const timer = setInterval(() => {
      settime((prevTime) => {
        if (prevTime > 0) {
          const updatedTime = prevTime - 1;
          localStorage.setItem("remainingTime", updatedTime);
          return updatedTime;
        } else {
          setResend(true);
          clearInterval(timer);
          return 0;
        }
      });
    }, 1000);


    return () => clearInterval(timer);
  }, [time]);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const resendOTP = () => {
    getOTP();
    settime(totalSeconds);
    setResend(false);
    localStorage.setItem("remainingTime", totalSeconds);
    localStorage.setItem("savedTimestamp", Date.now());
  }

  if (m == null || m == undefined) {
    return null
  }
  return (
    // <div className={styles.cta}>
    //   <div className={styles.buttonText}>
    //     <div className="timer">{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</div>
    //   </div>
    //   {!resend ?
    //     <div className={styles.secondaryButtonText}><span className={styles.resend} style={{ color: "lightgray" }}>Resend OTP</span></div> :
    //     <div className={styles.secondaryButtonText}><span className={styles.resend} onClick={resendOTP}>Resend OTP</span></div>
    //   }
    // </div>

    <div className={styles.cta}>
      {
        !resend ?
          <div className={styles.buttonText}>
            <div className="timer">{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</div>
          </div>
          :
          <div className={styles.secondaryButtonText}><span className={styles.resend} onClick={resendOTP}>Resend OTP</span></div>
      }
    </div>
  );
}


export const resetTimer = () => {
  const savedTime = localStorage.getItem("remainingTime");
  const savedTimestamp = localStorage.getItem("savedTimestamp");
  if (savedTime && savedTimestamp) {
    localStorage.removeItem("remainingTime");
    localStorage.removeItem("savedTimestamp");
  }
}


const logs = []
export const Logger = (action) => {
  const User = useSelector(state => state.User)
  logs.push(`UserName[${User.user_name}], Action: ${action}, on[${new Date().toISOString()}]`)
}

export const Breadcrumb = ({ paths }) => {
  return (
    <div className={helper.BreadcrumbsMenu}>
      <div>
        <Link to="/Dashboard" style={{ textAlign: "center" }}>All User</Link>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {paths.map((path, index) => (
          <div key={index}>
            <Link to={path.url}>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <div>
                  <Icon icon={chevronRight} />
                  {/* <img src="/chevron2.svg"  /> */}
                </div>
                <div>{path.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
// Debounce function
export const Debounce = (func, delay) => {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const NAME_CHECK = (val) => {
  let result = new RegExp(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g).test(val)
  return result
}
export const ALPHA_NUMERIC = (val) => {
  let result = new RegExp(/^[a-zA-Z0-9]+$/g).test(val)
  return result
}

export const NAME_CHECK_WITH_NUMBER = (val) => {
  // Accepts letters, numbers and common company-name punctuation
  // ( ) . , & - ' / with spaces between tokens.
  // Must start with an alphanumeric character; trailing punctuation
  // such as "Ltd." is allowed.
  let result = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9 .,&'/()-]*$/).test(val)
  return result
}

export const EMAIL_CHECK = (val) => {
  let result = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i).test(val)
  return result
}
export const PHONE_CHECK = (val) => {
  let result = new RegExp(/^(?:\+\d{2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val)
  return result
}

export const OVERSEAS_PHONE_CHECK=(val)=>{
  let result=new RegExp(/^[0-9\s\-\(\)]{7,15}$/).test(val)
  return result
}
export const PASSWORD_CHECK = (val) => {
  let result = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,13}$/).test(val)
  return result
}
export const GSTIN_REGEX = /^[0-9]{2}[A-Z0-9]{13}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/
export const PIN_REGEX = /^[0-9]{6}$/
export const CapitalizeFirstLetter = (string) => {
  string = string.toLowerCase();
  string = string.charAt(0).toUpperCase() + string.slice(1)
  return string.split(" ").reduce((s, c) => s + ' ' + (c.charAt(0).toUpperCase() + c.slice(1)));
}
export const _ToNormal = (str) => {
  if (str != null) {
    return CapitalizeFirstLetter(str.replace(/_/g, ' '))
  }

}
export const isNumber = function (val) {
  return !isNaN(val);
}
export const ObjectNotEmpty = function (val) {
  if (Object.keys(val).length > 0) return true
  else return false
}

export async function Delay(time = 1) {
  await new Promise(resolve => {
    setTimeout(() => resolve(), time * 1000)
  })
}

export const setDate = (dateStr) => {
  const dateObj = new Date(dateStr);
  const options = {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  return dateObj.toLocaleString('en-US', options);
}


export const resetDocument = () => {

  const keysToRemove = [localDataKeys.TAGS_DRAFT, localDataKeys.FILE_DRAFT, localDataKeys.SAVED, localDataKeys.DOCUMENT_DRAFT, localDataKeys.LAST_SAVE]

  keysToRemove.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const stringFormatter = (str, args) => {
  return str.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] != 'undefined'
      ? args[number]
      : match
      ;
  });
}
export const formatText = (text) => {
  return text
    ?.toLowerCase()
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}